/* Netwerkloods — productvergelijking: selectie, vergelijkknoppen, vergelijkbalk en groepsmelding.
   De selectie staat in localStorage van de bezoeker: product-ID, variant-ID, handle en weergavegegevens
   (naam, afbeelding, productgroep). Prijs en beschikbaarheid worden niet bewaard; de vergelijkingspagina
   haalt die altijd vers op uit Shopify. Een selectie die 24 uur niet is gebruikt, vervalt. */
(function () {
  'use strict';

  var theme = window.theme = window.theme || {};
  var KEY = 'prolec-compare-v2';
  var LEGACY_KEY = 'prolec-compare-v1';
  // Een selectie die een dag niet is gebruikt, vervalt. Zo begint een bezoeker die later terugkomt
  // met een lege vergelijklijst in plaats van oude producten van een eerder bezoek.
  var SAVED_AT_KEY = 'prolec-compare-saved-at';
  var MAX_AGE = 24 * 60 * 60 * 1000;
  var MAX = (theme.settings && theme.settings.compareMax) || 4;
  var memoryStore = [];
  var strings = {};

  try {
    var stringsEl = document.querySelector('[data-compare-strings]');
    if (stringsEl) strings = JSON.parse(stringsEl.textContent);
  } catch (e) { strings = {}; }

  function fill(text, values) {
    return String(text || '').replace(/\[(\w+)\]/g, function (m, k) {
      return values && values[k] != null ? values[k] : m;
    });
  }

  function sameItem(a, b) {
    if (a.productId && b.productId) return String(a.productId) === String(b.productId);
    return !!a.handle && a.handle === b.handle;
  }

  function clean(list) {
    var out = [];
    (Array.isArray(list) ? list : []).forEach(function (i) {
      if (!i || !(i.productId || i.handle)) return;
      if (out.some(function (o) { return sameItem(o, i); })) return;
      out.push({
        productId: i.productId ? String(i.productId) : '',
        variantId: i.variantId ? String(i.variantId) : '',
        handle: i.handle || '',
        title: i.title || i.handle || '',
        variantTitle: i.variantTitle || '',
        image: i.image || '',
        group: i.group || '',
        groupLabel: i.groupLabel || ''
      });
    });
    return out.slice(0, MAX);
  }

  function forget() {
    window.localStorage.removeItem(KEY);
    window.localStorage.removeItem(LEGACY_KEY);
    window.localStorage.removeItem(SAVED_AT_KEY);
  }

  function expired() {
    var savedAt = parseInt(window.localStorage.getItem(SAVED_AT_KEY), 10);
    // Zonder tijdstempel komt de selectie van voor deze regel en is hij dus oud.
    return !savedAt || Date.now() - savedAt > MAX_AGE;
  }

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (raw == null || expired()) {
        if (raw != null || window.localStorage.getItem(LEGACY_KEY) != null) forget();
        return [];
      }
      return clean(JSON.parse(raw));
    } catch (e) {
      return memoryStore.slice();
    }
  }

  // Wie de site blijft gebruiken, houdt de selectie: elk paginabezoek telt als gebruik.
  function touch() {
    try {
      if (window.localStorage.getItem(KEY) != null && !expired()) {
        window.localStorage.setItem(SAVED_AT_KEY, String(Date.now()));
      }
    } catch (e) { /* privé-modus: alleen in geheugen */ }
  }

  function write(list) {
    memoryStore = clean(list);
    reopenBar();
    try {
      window.localStorage.setItem(KEY, JSON.stringify(memoryStore));
      window.localStorage.setItem(SAVED_AT_KEY, String(Date.now()));
    } catch (e) { /* privé-modus: alleen in geheugen */ }
    document.dispatchEvent(new CustomEvent('compare:change', { detail: memoryStore.slice() }));
  }

  function currentGroup(list) {
    var withGroup = (list || read()).filter(function (i) { return i.group; });
    return withGroup.length ? { key: withGroup[0].group, label: withGroup[0].groupLabel } : null;
  }

  /* ---------- Melding bij een andere productgroep ---------- */
  function askReplace(item, group) {
    var text = fill(strings.conflict, { title: item.title, 'new': item.groupLabel || item.group, current: group.label || group.key });
    var dialog = document.querySelector('[data-compare-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') {
      return Promise.resolve(window.confirm(text));
    }
    var returnFocus = document.activeElement;
    dialog.querySelector('[data-compare-dialog-text]').textContent = text;
    return new Promise(function (resolve) {
      var answer = false;
      function onClick(e) {
        if (e.target.closest('[data-compare-dialog-replace]')) { answer = true; dialog.close(); }
        else if (e.target.closest('[data-compare-dialog-cancel]') || e.target === dialog) { dialog.close(); }
      }
      function onClose() {
        dialog.removeEventListener('click', onClick);
        dialog.removeEventListener('close', onClose);
        if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus();
        resolve(answer);
      }
      dialog.addEventListener('click', onClick);
      dialog.addEventListener('close', onClose);
      dialog.showModal();
      var cancel = dialog.querySelector('[data-compare-dialog-cancel]');
      if (cancel) cancel.focus();
    });
  }

  var store = {
    max: MAX,
    strings: strings,
    fill: fill,
    get: read,
    group: function () { return currentGroup(); },
    has: function (item) { return read().some(function (i) { return sameItem(i, item); }); },
    /* Voegt toe met alle controles. Resultaat: 'added', 'replaced', 'exists', 'full' of 'cancelled'. */
    request: function (item) {
      item = clean([item])[0];
      if (!item) return Promise.resolve('cancelled');
      var list = read();
      if (list.some(function (i) { return sameItem(i, item); })) return Promise.resolve('exists');
      var group = currentGroup(list);
      if (group && item.group && group.key !== item.group) {
        return askReplace(item, group).then(function (ok) {
          if (!ok) return 'cancelled';
          write([item]);
          return 'replaced';
        });
      }
      if (list.length >= MAX) return Promise.resolve('full');
      list.push(item);
      write(list);
      return Promise.resolve('added');
    },
    remove: function (item) {
      write(read().filter(function (i) { return !sameItem(i, item); }));
    },
    clear: function () { write([]); },
    /* Werkt opgeslagen weergavegegevens bij met verse gegevens uit Shopify. */
    update: function (item, patch) {
      var list = read();
      var changed = false;
      list.forEach(function (i) {
        if (!sameItem(i, item)) return;
        Object.keys(patch).forEach(function (k) {
          var val = patch[k] == null ? '' : String(patch[k]);
          if (i[k] !== val) { i[k] = val; changed = true; }
        });
      });
      if (changed) write(list);
    }
  };
  theme.compare = store;
  read();
  touch();

  function comparePageUrl() {
    var bar = document.querySelector('[data-compare-bar]');
    return (theme.routes && theme.routes.compare) || (bar && bar.getAttribute('data-compare-url')) || null;
  }

  /* ---------- Knoppen op kaarten en productpagina ---------- */
  function itemFromButton(btn) {
    var item = {
      productId: btn.getAttribute('data-compare-product-id'),
      variantId: btn.getAttribute('data-compare-variant-id'),
      handle: btn.getAttribute('data-compare-add'),
      title: btn.getAttribute('data-compare-title'),
      variantTitle: btn.getAttribute('data-compare-variant-title'),
      image: btn.getAttribute('data-compare-image'),
      group: btn.getAttribute('data-compare-group'),
      groupLabel: btn.getAttribute('data-compare-group-label')
    };
    // Productpagina: de uitvoering die de bezoeker nu gekozen heeft.
    if (btn.hasAttribute('data-compare-follow-variant')) {
      var scope = btn.closest('[data-product-info], .product, main') || document;
      var json = scope.querySelector('[data-selected-variant]') || document.querySelector('[data-selected-variant]');
      try {
        var variant = json ? JSON.parse(json.textContent) : null;
        if (variant && variant.id) {
          item.variantId = variant.id;
          if (item.variantTitle) item.variantTitle = variant.title || item.variantTitle;
          if (variant.featured_image && variant.featured_image.src) {
            item.image = variant.featured_image.src + (variant.featured_image.src.indexOf('?') === -1 ? '?' : '&') + 'width=120';
          }
        }
      } catch (e) { /* standaardvariant gebruiken */ }
    }
    return item;
  }

  function syncButtons() {
    var list = read();
    document.querySelectorAll('[data-compare-add]').forEach(function (btn) {
      var inList = list.some(function (i) {
        return sameItem(i, { productId: btn.getAttribute('data-compare-product-id'), handle: btn.getAttribute('data-compare-add') });
      });
      var pressed = inList ? 'true' : 'false';
      if (btn.getAttribute('aria-pressed') !== pressed) btn.setAttribute('aria-pressed', pressed);
      var title = btn.getAttribute('data-compare-title');
      var label = fill(inList ? strings.buttonAdded : strings.buttonAdd, { title: title });
      if (btn.hasAttribute('title') && label && btn.getAttribute('title') !== label) btn.setAttribute('title', label);
      var sr = btn.querySelector('[data-compare-sr-label]');
      if (sr && label && sr.textContent !== label) sr.textContent = label;
    });
  }

  var announcer;
  function announce(message) {
    if (!announcer) {
      announcer = document.createElement('p');
      announcer.className = 'visually-hidden';
      announcer.setAttribute('role', 'status');
      announcer.setAttribute('aria-live', 'polite');
      document.body.appendChild(announcer);
    }
    announcer.textContent = '';
    setTimeout(function () { announcer.textContent = message; }, 50);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-compare-add]');
    if (!btn) return;
    e.preventDefault();
    var item = itemFromButton(btn);
    // Geen pop-up bij toevoegen of verwijderen: de knop en de balk laten het al zien.
    // Schermlezers krijgen een korte melding.
    if (store.has(item)) {
      store.remove(item);
      announce(fill(strings.removedToast, { title: item.title }));
      return;
    }
    store.request(item).then(function (result) {
      if (result === 'added') announce(fill(strings.addedToast, { title: item.title }));
      else if (result === 'replaced') announce(fill(strings.conflictReplaced, { title: item.title }));
      else if (result === 'full') {
        var url = comparePageUrl();
        theme.toast(strings.full, url, url ? strings.go : null);
      }
    });
  });

  /* ---------- Vergelijkbalk ---------- */
  var ICON_X = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

  function renderBar() {
    var bar = document.querySelector('[data-compare-bar]');
    if (!bar) return;
    var list = read();
    var itemsEl = bar.querySelector('[data-compare-bar-items]');
    var countEl = bar.querySelector('[data-compare-bar-count]');
    var go = bar.querySelector('[data-compare-go]');
    var hint = bar.querySelector('[data-compare-bar-hint]');

    // Focus bewaren als een verwijderknop wegvalt.
    var hadFocus = bar.contains(document.activeElement);

    itemsEl.innerHTML = '';
    list.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'compare-bar__item';
      var thumb = document.createElement('span');
      thumb.className = 'compare-bar__thumb';
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image;
        img.alt = '';
        img.width = 48;
        img.height = 48;
        img.loading = 'lazy';
        thumb.appendChild(img);
      }
      var name = document.createElement('span');
      name.className = 'compare-bar__name';
      name.textContent = item.title + (item.variantTitle ? ' – ' + item.variantTitle : '');
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'compare-bar__remove';
      remove.setAttribute('data-compare-bar-remove', item.productId || item.handle);
      remove.setAttribute('aria-label', (strings.remove || '') + ': ' + item.title);
      remove.innerHTML = ICON_X;
      li.appendChild(thumb);
      li.appendChild(name);
      li.appendChild(remove);
      itemsEl.appendChild(li);
    });

    if (countEl) countEl.textContent = fill(strings.count, { count: list.length });
    var ready = list.length >= 2;
    if (go) {
      go.classList.toggle('is-disabled', !ready);
      go.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }
    if (hint) hint.textContent = ready ? '' : (strings.needMore || '');
    renderAdd(list);

    var visible = list.length > 0 && !barClosed(list);
    bar.hidden = !visible;
    requestAnimationFrame(function () {
      bar.classList.toggle('is-visible', visible);
      setBarSpace();
    });
    document.body.classList.toggle('has-compare-bar', visible);
    if (hadFocus && !bar.contains(document.activeElement)) {
      var next = bar.querySelector('.compare-bar__remove') || bar.querySelector('[data-compare-go]');
      if (visible && next) next.focus();
    }
  }

  // Gesloten balk blijft dicht tot de selectie verandert (ook op andere pagina's).
  var CLOSED_KEY = 'prolec-compare-bar-closed';
  var closedMemory = null;
  function signature(list) {
    return list.map(function (i) { return i.productId || i.handle; }).join(',');
  }
  function barClosed(list) {
    var sig = closedMemory;
    try { sig = window.sessionStorage.getItem(CLOSED_KEY); } catch (e) { /* alleen in geheugen */ }
    return sig != null && sig === signature(list);
  }
  function reopenBar() {
    closedMemory = null;
    try { window.sessionStorage.removeItem(CLOSED_KEY); } catch (e) { /* alleen in geheugen */ }
  }
  function closeBar() {
    closedMemory = signature(read());
    try { window.sessionStorage.setItem(CLOSED_KEY, closedMemory); } catch (e) { /* alleen in geheugen */ }
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    renderBar();
  }

  // Ruimte onder de pagina reserveren zodat de balk geen knoppen of tekst bedekt.
  function setBarSpace() {
    var bar = document.querySelector('[data-compare-bar]');
    var h = bar && !bar.hidden ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--compare-bar-height', h + 'px');
  }
  window.addEventListener('resize', theme.debounce ? theme.debounce(setBarSpace, 100) : setBarSpace);

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-compare-bar-remove]');
    if (remove) {
      var id = remove.getAttribute('data-compare-bar-remove');
      store.remove(/^\d+$/.test(id) ? { productId: id } : { handle: id });
      return;
    }
    if (e.target.closest('[data-compare-bar-close]')) {
      closeBar();
      return;
    }
    if (e.target.closest('[data-compare-clear]')) {
      store.clear();
      return;
    }
    var go = e.target.closest('[data-compare-go]');
    if (go) {
      if (go.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        theme.toast(strings.needMore);
      } else if (!comparePageUrl()) {
        e.preventDefault();
        theme.toast(strings.noPage);
      }
    }
  });

  /* ---------- Zoeken en toevoegen vanuit de balk ---------- */
  // Zoekt via Shopify predictive search (sectie compare-suggest levert de productgroep mee)
  // en biedt alleen producten uit dezelfde productgroep aan die nog niet gekozen zijn.
  var search = {
    wrap: null, open: null, box: null, input: null, popup: null, list: null, note: null, help: null, status: null,
    results: [], active: -1, controller: null, timer: null, query: ''
  };

  function initSearch() {
    var wrap = document.querySelector('[data-compare-bar-add]');
    if (!wrap || search.wrap === wrap) return;
    search.wrap = wrap;
    search.open = wrap.querySelector('[data-compare-bar-add-open]');
    search.box = wrap.querySelector('[data-compare-bar-search]');
    search.input = wrap.querySelector('[data-compare-bar-input]');
    search.popup = wrap.querySelector('[data-compare-bar-popup]');
    search.list = wrap.querySelector('[data-compare-bar-results]');
    search.note = wrap.querySelector('[data-compare-bar-note]');
    search.help = wrap.querySelector('[data-compare-bar-search-help]');
    search.status = wrap.querySelector('[data-compare-bar-search-status]');

    search.open.addEventListener('click', openSearch);
    wrap.querySelector('[data-compare-bar-search-close]').addEventListener('click', function () { closeSearch(true); });
    search.input.addEventListener('input', function () {
      clearTimeout(search.timer);
      search.timer = setTimeout(runSearch, 200);
    });
    search.input.addEventListener('keydown', onSearchKey);
    search.list.addEventListener('mousedown', function (e) { e.preventDefault(); }); // focus in het veld houden
    search.list.addEventListener('click', function (e) {
      var opt = e.target.closest('[role="option"]');
      if (opt) pickResult(Number(opt.getAttribute('data-index')));
    });
    document.addEventListener('click', function (e) {
      if (!search.box.hidden && !wrap.contains(e.target)) closeSearch(false);
    });
  }

  function groupHelp() {
    var group = currentGroup();
    return group ? fill(strings.searchGroup, { group: group.label || group.key }) : '';
  }

  function openSearch() {
    search.open.hidden = true;
    search.box.hidden = false;
    search.wrap.classList.add('is-searching');
    search.wrap.parentNode.classList.add('is-searching');
    search.input.value = '';
    search.input.focus();
    // Een openstaande melding zou over de voorstellen vallen.
    var toastEl = document.getElementById('ThemeToast');
    if (toastEl) toastEl.hidden = true;
    showSimilar();
    setBarSpace();
  }

  function closeSearch(focusButton) {
    if (!search.box || search.box.hidden) return;
    clearTimeout(search.timer);
    if (search.controller) search.controller.abort();
    search.box.hidden = true;
    search.wrap.classList.remove('is-searching');
    search.wrap.parentNode.classList.remove('is-searching');
    hidePopup();
    search.open.hidden = false;
    if (focusButton && !search.wrap.hidden) search.open.focus();
    setBarSpace();
  }

  function hidePopup() {
    search.popup.hidden = true;
    search.input.setAttribute('aria-expanded', 'false');
    search.input.removeAttribute('aria-activedescendant');
    search.list.innerHTML = '';
    search.results = [];
    search.active = -1;
  }

  function showPopup(note, results) {
    search.results = results;
    search.active = -1;
    search.input.removeAttribute('aria-activedescendant');
    var help = groupHelp();
    search.note.textContent = [note, results.length ? help : ''].filter(Boolean).join(' ');
    search.note.hidden = !search.note.textContent;
    search.list.innerHTML = '';
    results.forEach(function (r, i) {
      var li = document.createElement('li');
      li.id = 'CompareBarResult-' + i;
      li.className = 'compare-bar__result';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.setAttribute('data-index', i);
      var thumb = document.createElement('span');
      thumb.className = 'compare-bar__thumb';
      if (r.image) {
        var img = document.createElement('img');
        img.src = r.image;
        img.alt = '';
        img.width = 40;
        img.height = 40;
        thumb.appendChild(img);
      }
      var text = document.createElement('span');
      text.className = 'compare-bar__result-text';
      var name = document.createElement('span');
      name.className = 'compare-bar__result-name';
      name.textContent = r.title + (r.variantTitle ? ' – ' + r.variantTitle : '');
      text.appendChild(name);
      if (r.detail) {
        var detail = document.createElement('span');
        detail.className = 'compare-bar__result-detail';
        detail.textContent = r.detail;
        text.appendChild(detail);
      }
      if (r.price) {
        var price = document.createElement('span');
        price.className = 'compare-bar__result-price';
        price.textContent = r.price + (r.priceVat ? ' · ' + r.priceVat : '');
        text.appendChild(price);
      }
      li.appendChild(thumb);
      li.appendChild(text);
      search.list.appendChild(li);
    });
    search.list.hidden = results.length === 0;
    search.popup.hidden = false;
    search.input.setAttribute('aria-expanded', results.length ? 'true' : 'false');
    if (search.status) {
      search.status.textContent = results.length ? fill(strings.searchResults, { count: results.length }) : note;
    }
  }

  function runSearch() {
    var q = search.input.value.trim();
    search.query = q;
    search.similarToken = (search.similarToken || 0) + 1;
    if (search.controller) search.controller.abort();
    if (q.length < 2) {
      showSimilar();
      return;
    }
    showPopup(strings.searchLoading, []);
    var base = (theme.routes && theme.routes.predictiveSearch) || '/search/suggest';
    var url = base + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&section_id=compare-suggest';
    var controller = search.controller = new AbortController();
    fetch(url, { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        if (controller !== search.controller || search.box.hidden) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var json = doc.querySelector('[data-compare-suggest-json]');
        var products = json ? JSON.parse(json.textContent) : [];
        var list = read();
        var group = currentGroup(list);
        var fresh = products.filter(function (p) {
          return !list.some(function (i) { return sameItem(i, { productId: String(p.productId), handle: p.handle }); });
        });
        var matching = fresh.filter(function (p) { return !group || !p.group || p.group === group.key; });
        var note = '';
        if (!matching.length) {
          note = group && fresh.length
            ? fill(strings.searchNoneGroup, { query: q, group: group.label || group.key })
            : fill(strings.searchNone, { query: q });
        }
        showPopup(note, matching);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (controller === search.controller) showPopup(strings.loadError, []);
      });
  }

  function setActive(index) {
    var options = search.list.querySelectorAll('[role="option"]');
    if (!options.length) return;
    if (index < 0) index = options.length - 1;
    if (index >= options.length) index = 0;
    options.forEach(function (o, i) { o.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
    search.active = index;
    search.input.setAttribute('aria-activedescendant', options[index].id);
    options[index].scrollIntoView({ block: 'nearest' });
  }

  function onSearchKey(e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(search.active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(search.active - 1); }
    else if (e.key === 'Enter') {
      e.preventDefault();
      if (search.active >= 0) pickResult(search.active);
      else if (search.results.length === 1) pickResult(0);
    } else if (e.key === 'Escape') {
      e.preventDefault();
      closeSearch(true);
    }
  }

  function pickResult(index) {
    var r = search.results[index];
    if (!r) return;
    var item = {
      productId: r.productId, variantId: r.variantId, handle: r.handle, title: r.title,
      variantTitle: r.variantTitle, image: r.image, group: r.group, groupLabel: r.groupLabel
    };
    store.request(item).then(function (result) {
      if (result === 'added' || result === 'replaced') {
        announce(fill(result === 'added' ? strings.addedToast : strings.conflictReplaced, { title: item.title }));
        closeSearch(true);
      } else if (result === 'full') {
        theme.toast(strings.full);
        closeSearch(true);
      } else if (result === 'exists') {
        theme.toast(fill(strings.exists, { title: item.title }));
      } else {
        search.input.focus();
      }
    });
  }

  /* Voorstellen zonder te typen: producten uit dezelfde groep die op de gekozen producten
     lijken (veel gelijke specificaties), maar nog niet gekozen zijn. */
  var refCache = {};
  var poolCache = {};
  var SIMILAR_MAX = 4;

  function sectionJson(url, selector) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? JSON.parse(el.textContent) : null;
    });
  }

  function specMap(specs) {
    var map = {};
    (specs || []).forEach(function (row) {
      if (row && row.value != null && row.key !== 'ecosystem') map[row.key] = { label: row.label, value: String(row.value) };
    });
    return map;
  }

  function loadRef(item) {
    var key = item.productId || item.handle;
    if (!refCache[key]) {
      var url = (theme.routes && theme.routes.root || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(item.handle) +
        (item.variantId ? '?variant=' + item.variantId + '&' : '?') + 'section_id=compare-data';
      refCache[key] = sectionJson(url, '[data-compare-json]').catch(function () { return null; });
    }
    return refCache[key];
  }

  function loadPool(url) {
    if (!poolCache[url]) {
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      poolCache[url] = sectionJson(url + sep + 'section_id=compare-suggest', '[data-compare-suggest-json]')
        .then(function (list) { return list || []; })
        .catch(function () { return []; });
    }
    return poolCache[url];
  }

  function rankSimilar(list, refs, pool) {
    var group = currentGroup(list);
    var seen = {};
    var refMaps = refs.map(function (r) { return specMap(r.specs); });
    var ranked = [];
    pool.forEach(function (p) {
      var id = String(p.productId);
      if (seen[id]) return;
      seen[id] = true;
      if (group && p.group && p.group !== group.key) return;
      if (list.some(function (i) { return sameItem(i, { productId: id, handle: p.handle }); })) return;
      var mine = specMap(p.specs);
      var score = 0;
      var same = [];
      var diff = [];
      refMaps.forEach(function (ref, n) {
        var compared = 0;
        var equal = 0;
        Object.keys(ref).forEach(function (k) {
          if (!mine[k]) return;
          compared++;
          if (mine[k].value === ref[k].value) {
            equal++;
            if (n === 0 && same.length < 2) same.push(mine[k].value);
          } else if (n === 0 && diff.length < 1) {
            diff.push(mine[k].value);
          }
        });
        score += compared ? equal / compared : 0;
      });
      var parts = [];
      if (same.length) parts.push(fill(strings.similarSame, { list: same.join(', ') }));
      if (diff.length) parts.push(fill(strings.similarDiff, { list: diff.join(', ') }));
      ranked.push({ item: p, score: score, detail: parts.join(' · ') });
    });
    ranked.sort(function (a, b) { return b.score - a.score; });
    return ranked.slice(0, SIMILAR_MAX).map(function (r) {
      var out = {};
      Object.keys(r.item).forEach(function (k) { if (k !== 'specs') out[k] = r.item[k]; });
      out.detail = r.detail;
      return out;
    });
  }

  function showSimilar() {
    var list = read();
    var token = search.similarToken = (search.similarToken || 0) + 1;
    if (!list.length) { showPopup(strings.searchMin, []); return; }
    showPopup(strings.similarLoading, []);
    Promise.all(list.map(loadRef)).then(function (refs) {
      refs = refs.filter(Boolean);
      var urls = [];
      refs.forEach(function (r) { if (r.collectionUrl && urls.indexOf(r.collectionUrl) === -1) urls.push(r.collectionUrl); });
      return Promise.all(urls.map(loadPool)).then(function (pools) {
        var pool = [].concat.apply([], pools);
        var ranked = rankSimilar(list, refs, pool);
        if (ranked.length >= 2) return ranked;
        // Te weinig in de eigen collectie: ook het hele assortiment bekijken.
        var all = (theme.routes && theme.routes.root || '/').replace(/\/$/, '') + '/collections/all';
        return Promise.all([loadPool(all), loadPool(all + '?page=2')]).then(function (more) {
          return rankSimilar(list, refs, pool.concat(more[0], more[1]));
        });
      });
    }).then(function (ranked) {
      if (token !== search.similarToken || search.box.hidden || search.input.value.trim().length >= 2) return;
      showPopup(ranked.length ? strings.similarTitle : strings.searchMin, ranked);
    });
  }

  function renderAdd(list) {
    initSearch();
    if (!search.wrap) return;
    var canAdd = list.length > 0 && list.length < MAX;
    if (!canAdd) closeSearch(false);
    search.wrap.hidden = !canAdd;
    // Op mobiel alleen het plusje tonen als er al 3 producten in de balk staan.
    search.wrap.classList.toggle('is-compact', list.length >= 3);
    if (search.help) search.help.textContent = groupHelp();
  }

  function refresh() {
    syncButtons();
    renderBar();
  }

  document.addEventListener('compare:change', refresh);
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) refresh();
  });
  // Terug-knop (bfcache): selectie kan op een andere pagina gewijzigd zijn.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('shopify:section:load', syncButtons);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();

  // Na filteren of varianten wisselen worden knoppen vervangen; opnieuw synchroniseren.
  new MutationObserver(theme.debounce ? theme.debounce(syncButtons, 100) : syncButtons)
    .observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
